class InvariantError extends Error {}

/**
 * Throws an `InvariantError` with the given `message` if `condition` is `false`
 */
export function assert(
  condition: any,
  message?: string | (() => string)
): asserts condition {
  if (!condition) {
    throw new InvariantError(
      typeof message === "function" ? message() : message
    );
  }
}
